export default __webpack_public_path__ + "static/media/fileIcon.5ac30da4.svg";